var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPercentage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00027 0C3.14028 0 0 3.14016 0 7C0 10.8598 3.14028 14 7.00027 14C10.86 14 14 10.8598 14 7C14 3.14016 10.86 0 7.00027 0ZM4.97019 3.28371C5.90101 3.28371 6.65846 4.04113 6.65846 4.97219C6.65846 5.90297 5.90101 6.66039 4.97019 6.66039C4.0391 6.66039 3.28165 5.90297 3.28165 4.97219C3.28138 4.04113 4.0391 3.28371 4.97019 3.28371ZM4.45666 10.1623C4.37134 10.2479 4.25896 10.2908 4.14712 10.2908C4.035 10.2908 3.92289 10.2479 3.83757 10.1623C3.66667 9.99141 3.66667 9.71387 3.83757 9.54324L9.54307 3.8377C9.71397 3.6668 9.99125 3.6668 10.1622 3.8377C10.3331 4.00859 10.3331 4.28613 10.1622 4.45676L4.45666 10.1623ZM9.02078 10.7108C8.08969 10.7108 7.33224 9.9534 7.33224 9.02234C7.33224 8.09156 8.08969 7.33414 9.02078 7.33414C9.9516 7.33414 10.7091 8.09156 10.7091 9.02234C10.7091 9.9534 9.9516 10.7108 9.02078 10.7108Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentage);
export default __webpack_public_path__ + "static/media/percentage.a6db57af.svg";
export { ForwardRef as ReactComponent };